import * as yup from "yup";

export const paymentMethodFormSchema = yup.object({
    number: yup
        .string()
        // .matches(/^[0-9]{16}$/, "Invalid card number")
        .required("Número de tarjeta requerido."),
    expiry: yup
        .string()
        .required("Fecha de expiración requerida.")
        .test("valid-month", "mes inválido.", function (value) {
            if (!value) {
                return false;
            }

            const [month] = value.split("/").map((item) => parseInt(item, 10));

            return month >= 1 && month <= 12;
        })
        .test(
            "is-future-date",
            "Fecha de expiración debe ser posterior al día actual.",
            function (value) {
                if (!value) {
                    return false;
                }

                const currentDate = new Date();
                const [month, year] = value
                    .split("/")
                    .map((item) => parseInt(item, 10));

                // Adding 1 to the month because JavaScript months are zero-indexed
                const expiryDate = new Date(year + 2000, month, 1);

                return expiryDate > currentDate;
            }
        ),
    name: yup.string().required("Nombre es requerido."),
    tipoDocumento: yup.string().required("Tipo de Documento requerido."),
    documento: yup.number("El documento debe ser un número").required("Documento requerido."),
    cvc: yup
        .string()
        .matches(/^[0-9]{3,4}$/, "CVV Inválido.")
        .required("CVV es requerido."),
});
